import React from 'react';
import { Divider } from '@meitu/saas-ui';

export const DividerLine: React.FC<{
    style?: React.CSSProperties;
}> = React.memo(({ style }) => {
    return <Divider plain style={{ borderBlockWidth: 6, margin: '16px', width: 228, minWidth: 228, ...style }} />;
});
